import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";
import { axiosInstance } from "@helpers/axios-instance";

export function DictionaryLookupDS(type?: string) {
  let query = `?getActive=true`;

  if (type) {
    query += `&type=${type}`;
  }

  return new DataSource({
    store: new CustomStore({
      key: "id",
      load: async (loadOptions) => {
        return axiosInstance({
          method: "POST",
          url:  `Dictionary/GetLookup${query}`,
          data: loadOptions,
        })
          .then((response) => {
            return response.data;
          })
          .catch((err) => {
            console.error(err);
          });
      },
      byKey: async (key) => {
        return axiosInstance({
          method: "GET",
          url:  `Dictionary/Get?id=${key}`,
        })
          .then((response) => {
            return response.data.data;
          })
          .catch((err) => {
            console.error(err);
          });
      },
    }),
  });
}
